import type { WireTransaction } from '../api/types.ts';

/**
 * "Example" and "check" markers on plan items (from Start): a marker shows while the item still has
 * the fingerprint it was marked with, so any edit to what the person sees clears it, with no write.
 */
export type MarkKind = 'example' | 'check';

const SEEN_FIELDS = [
  'label', 'type', 'amount', 'frequency', 'paymentDayOfMonth', 'startDate', 'endDate', 'annualIncreasePercent', 'interestRate', 'initialBalance',
  'employerMatch', 'debtCurrentBalance', 'isActive',
] as const;

/** cyrb53: a fast 53-bit string hash, enough to tell an edited item from the one that was marked. */
function hash53(text: string): number {
  let h1 = 0xdeadbeef;
  let h2 = 0x41c6ce57;
  for (let i = 0; i < text.length; i++) {
    const ch = text.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909);
  return 4294967296 * (2097151 & h2) + (h1 >>> 0);
}

export function markFingerprint(item: WireTransaction): string {
  const seen = SEEN_FIELDS.map((f) => {
    const v = item[f];
    return v === undefined ? null : typeof v === 'object' ? JSON.stringify(v) : String(v);
  });
  return hash53(JSON.stringify(seen)).toString(36);
}

export const markStillApplies = (item: WireTransaction, fingerprint: string): boolean => markFingerprint(item) === fingerprint;
